import axios from "axios";

function voucherApi() {
	// 創建axios
	const API_URL = process.env.REACT_APP_VOUCHER_API_URL;
	const instance = axios.create({
		baseURL: API_URL,
		headers: {
			'Content-Type': 'application/json',
			'Authorization': process.env.REACT_APP_VOUCHER_API_KEY,
		},
	});

	
	return instance;
}

export default voucherApi();
